import Vue from 'vue'

Vue.component('NewTargetModal', () => import('./NewTargetModal.vue'))